import { Injectable } from '@angular/core';

import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import {  GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { StudentAssignmentModel } from 'common/models/page-models/Student Assignment/student-assignment-data.model';
import { StudentAssignmentListingModel } from 'common/models/page-models/Student Assignment/student-assignment-grid-model';

@Injectable({
    providedIn: 'root'
})
export class StudentAssignmentGridDataService extends GridDataService<StudentAssignmentListingModel,StudentAssignmentModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.StudentToDoAssignmentDetails, http, ss);
        
    } 
    createInstance(): StudentAssignmentListingModel {
        return new StudentAssignmentListingModel();
    }

    getGridParams(param): GridPostParams {
        const payload = {
            assignmentType:1
        }
        return payload;
    }

    getDeleteUrl(): string {
        return "";
    }
    override getDataParam(): string {
        return 'details';
    }

}
